// extracted by mini-css-extract-plugin
module.exports = {"videoButton":"VideoPlayer_videoButton__a16JX","videoWrapper":"VideoPlayer_videoWrapper__7O5Rn","videoControls":"VideoPlayer_videoControls__Wabjp"};